import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Experience from "./experience/Experience";
import AboutUs from "./pages/AboutUs";
import WhatsAppButton from "./components/WhatsAppButton";

function App() {
  return (
    <div className="App min-h-screen bg-[#0A0A0A]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Experience />} />
          <Route path="/about" element={<AboutUs />} />
        </Routes>
        <WhatsAppButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
